import { contactValidator } from './contactValidator.routes';
import { patientRegistration } from './patientRegistration.routes';

const patientDataRoutes = [
  ...patientRegistration,
  ...contactValidator
];

export default patientDataRoutes;
